/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rte_Drag_HandleInputs */



/**
* | output |
* | --- |
* | "Move block" |
*
* @param {Rte_Drag_HandleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const rte_drag_handle = /** @type {((inputs?: Rte_Drag_HandleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rte_Drag_HandleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Blok verplaatsen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déplacer le bloc")
	return /** @type {LocalizedString} */ ("Move block")
});